// Names are derived from https://www.figma.com/file/SX3ERxSqpnu6XS1k3EUOzn/Editor-3.0?node-id=3572%3A356714
export const APP_COLOR_PICKER = {
  // Top Row
  BLACK: '#000000',
  DARKER_GRAY: '#434343',
  DARK_GRAY: '#5E5E5E',
  MEDIUM_GRAY: '#999999',
  GRAY: '#B7B7B7',
  LIGHT_GRAY: '#CBCBCB',
  LIGHTER_GRAY: '#D6D6D6',
  WHITE: '#EFEFEF',

  // Row 1
  DARK_BLUE: '#1E4C7C',
  DARK_TEAL: '#2D6A65',
  DARK_GREEN: '#306F1D',
  MUSTARD: '#C7A01A',
  DARK_ORANGE: '#B05311',
  DARK_RED: '#A62B17',
  DARK_MAGENTA: '#8A2052',
  DARK_PURPLE: '#4B2873',

  // Row 2
  OCEAN_BLUE: '#3274B5',
  TEAL: '#4CA98F',
  GREEN: '#54AE32',
  YELLOW: '#F4CE46',
  ORANGE: '#EE9351',
  RED: '#DA3B26',
  MAGENTA: '#C23175',
  PURPLE: '#8754BA',

  // Row 3
  BLUE: '#479FF8',
  MEDIUM_TEAL: '#6EDDCA',
  MEDIUM_GREEN: '#8FD669',
  MEDIUM_YELLOW: '#F8DC65',
  TANGERINE: '#F9AE79',
  BRICK_RED: '#ED6E57',
  PINK: '#EB539F',
  SOFT_PURPLE: '#A981D0',

  // Row 4
  SKY_BLUE: '#73BFF9',
  BRIGHT_TEAL: '#A0F5E7',
  BRIGHT_GREEN: '#ADF27D',
  BRIGHT_YELLOW: '#FFF184',
  BRIGHT_ORANGE: '#F9C270',
  LIGHT_RED: '#EFA296',
  LIGHT_PINK: '#EC99C2',
  LIGHT_PURPLE: '#D2B3F0',

  // Row 5
  LIGHT_BLUE: '#E3ECFF',
  LIGHT_TEAL: '#E1FAF5',
  LIGHT_GREEN: '#DCFAE0',
  LIGHT_YELLOW: '#FCF9DE',
  LIGHT_ORANGE: '#FCEBCC',
  BLUSH_RED: '#FFEBE8',
  LIGHTER_PINK: '#FFF0F9',
  LIGHTER_PURPLE: '#F3EAFC',

  // ROW 6 : Dark Gradients
  DARK_GRAY_GRADIENT: 'linear-gradient(90deg, #212943 0%, #839C93 100%)',
  DARK_BLUE_GRADIENT: 'linear-gradient(90deg, #430FB0 0%, #2270C7 50%, #0DCBB4 100%)',
  BLUE_GREEN_GRADIENT: 'linear-gradient(90deg, #036685 0%, #159D64 50%, #80BC01 100%)',
  YELLOW_GREEN_GRADIENT: 'linear-gradient(90deg, #27D194 0%, #7FD124 50%, #D5CC05 100%)',
  ORANGE_RED_GRADIENT: 'linear-gradient(90deg, #D80B5D 0%, #F45B1A 50%, #F09100 100%)',
  RED_PINK_GRADIENT: 'linear-gradient(90deg, #A133F8 0%, #DB1273 50%, #F76513 100%)',
  BLUE_PINK_GRADIENT: 'linear-gradient(90deg, #F532A7 0%, #8961FB 50%, #2BC6F7 100%)',
  PURPLE_PINK_GRADIENT: 'linear-gradient(90deg, #4811BD 0%, #9302A8 50%, #EC249C 100%)',

  // Row 7 : Light Gradients
  LIGHT_GRAY_GRADIENT: 'linear-gradient(90deg, #DADEE3 0%, #ECF3F4 100%)',
  LIGHT_BLUE_GRADIENT: 'linear-gradient(90deg, #ECE5FC 0%, #E1FBF5 100%)',
  LIGHT_BLUE_GREEN_GRADIENT: 'linear-gradient(90deg, #DEEFFF 0%, #EAFBD9 100%)',
  LIGHT_YELLOW_GREEN_GRADIENT: 'linear-gradient(90deg, #DEF8DC 0%, #FFF8D5 100%)',
  LIGHT_ORANGE_RED_GRADIENT: 'linear-gradient(90deg, #FFD8E3 0%, #FDEFCB 100%)',
  LIGHT_RED_PINK_GRADIENT: 'linear-gradient(90deg, #F6E3FF 0%, #FFE1ED 50%, #FEE2D6 100%)',
  LIGHT_BLUE_PINK_GRADIENT: 'linear-gradient(90deg, #FFE7F6 0%, #EEE9FF 50%, #E3F8FE 100%)',
  LIGHT_PURPLE_PINK_GRADIENT: 'linear-gradient(90deg, #E7E3FF 0%, #FFE6FA 100%)',

  // ROW 1: BOX/Callout Colors
  BOX_LIGHT_GRAY: '#EDEEF0',
  BOX_LIGHT_BLUE: '#E3ECFF',
  BOX_LIGHT_GREEN: '#D9FFDF',
  BOX_LIGHT_YELLOW: '#FFF7E8',
  BOX_LIGHT_ORANGE: '#FFF0E5',
  BOX_LIGHT_RED: '#FFEBE8',
  BOX_LIGHT_PINK: '#FFF5FB',
  BOX_LIGHT_PURPLE: '#F2E5FF',
  BOX_DARK_GRAY: '#A3AAB8',
  BOX_DARK_BLUE: '#9DBDF2',
  BOX_DARK_GREEN: '#9FEBAB',
  BOX_DARK_YELLOW: '#FFE8AE',
  BOX_DARK_ORANGE: '#FFCFAD',
  BOX_DARK_RED: '#FFBDB8',
  BOX_DARK_PINK: '#FCB3DE',
  BOX_DARK_PURPLE: '#D0AEF2',

  /* Extra Colors
   * Names are derived via https://color-name-generator.com/
   **/
  AFTER_WORK_BLUE: '#1C266F',
  NATURES_MASTERPIECE: '#006310',
  CAFFEINATED_CINNAMON: '#845210',
  ESPRESSO_MARTINI: '#853B07',
  FALU_RED: '#801C16',
  DARK_RASPBERRY: '#8C2360',
  ORIENTAL_NIGHTS: '#4D2873',
  DARK_SEA: '#4E5561',
  CERULEAN_BLUE: '#2F5EBC',
  GREEN_GARDENS: '#009918',
  XANTHOUS: '#EDB62C',
  CHAAT_MASALA: '#ED7C2C',
  CUTE_CRAB: '#DD4740',
  ORION: '#E65CAC',
  SUIT_BLUE: '#2B2F38',
  KETTLEMAN: '#606060',
  CODEX_GREY: '#9C9C9C',
  TANGLED_WEB: '#B2B2B2',
  COMPACT_DISC_GREY: '#CDCDCD',
  SNOWBANK: '#E9E9E9',
  PURE_WHITE: '#FFFFFF',
}

const sharedColorOptions = [
  // Row 1
  APP_COLOR_PICKER.DARK_BLUE,
  APP_COLOR_PICKER.DARK_TEAL,
  APP_COLOR_PICKER.DARK_GREEN,
  APP_COLOR_PICKER.MUSTARD,
  APP_COLOR_PICKER.DARK_ORANGE,
  APP_COLOR_PICKER.DARK_RED,
  APP_COLOR_PICKER.DARK_MAGENTA,
  APP_COLOR_PICKER.DARK_PURPLE,

  // Row 2
  APP_COLOR_PICKER.OCEAN_BLUE,
  APP_COLOR_PICKER.TEAL,
  APP_COLOR_PICKER.GREEN,
  APP_COLOR_PICKER.YELLOW,
  APP_COLOR_PICKER.ORANGE,
  APP_COLOR_PICKER.RED,
  APP_COLOR_PICKER.MAGENTA,
  APP_COLOR_PICKER.PURPLE,

  // Row 3
  APP_COLOR_PICKER.BLUE,
  APP_COLOR_PICKER.MEDIUM_TEAL,
  APP_COLOR_PICKER.MEDIUM_GREEN,
  APP_COLOR_PICKER.MEDIUM_YELLOW,
  APP_COLOR_PICKER.TANGERINE,
  APP_COLOR_PICKER.BRICK_RED,
  APP_COLOR_PICKER.PINK,
  APP_COLOR_PICKER.SOFT_PURPLE,

  // Row 4
  APP_COLOR_PICKER.SKY_BLUE,
  APP_COLOR_PICKER.BRIGHT_TEAL,
  APP_COLOR_PICKER.BRIGHT_GREEN,
  APP_COLOR_PICKER.BRIGHT_YELLOW,
  APP_COLOR_PICKER.BRIGHT_ORANGE,
  APP_COLOR_PICKER.LIGHT_RED,
  APP_COLOR_PICKER.LIGHT_PINK,
  APP_COLOR_PICKER.LIGHT_PURPLE,

  // Row 5
  APP_COLOR_PICKER.LIGHT_BLUE,
  APP_COLOR_PICKER.LIGHT_TEAL,
  APP_COLOR_PICKER.LIGHT_GREEN,
  APP_COLOR_PICKER.LIGHT_YELLOW,
  APP_COLOR_PICKER.LIGHT_ORANGE,
  APP_COLOR_PICKER.BLUSH_RED,
  APP_COLOR_PICKER.LIGHTER_PINK,
  APP_COLOR_PICKER.LIGHTER_PURPLE,
]

export const SHARED_GRADIENTS = [
  // ROW 6 : Dark Gradients
  APP_COLOR_PICKER.DARK_GRAY_GRADIENT,
  APP_COLOR_PICKER.DARK_BLUE_GRADIENT,
  APP_COLOR_PICKER.BLUE_GREEN_GRADIENT,
  APP_COLOR_PICKER.YELLOW_GREEN_GRADIENT,
  APP_COLOR_PICKER.ORANGE_RED_GRADIENT,
  APP_COLOR_PICKER.RED_PINK_GRADIENT,
  APP_COLOR_PICKER.BLUE_PINK_GRADIENT,
  APP_COLOR_PICKER.PURPLE_PINK_GRADIENT,

  // Row 7 : Light Gradients
  APP_COLOR_PICKER.LIGHT_GRAY_GRADIENT,
  APP_COLOR_PICKER.LIGHT_BLUE_GRADIENT,
  APP_COLOR_PICKER.LIGHT_BLUE_GREEN_GRADIENT,
  APP_COLOR_PICKER.LIGHT_YELLOW_GREEN_GRADIENT,
  APP_COLOR_PICKER.LIGHT_ORANGE_RED_GRADIENT,
  APP_COLOR_PICKER.LIGHT_RED_PINK_GRADIENT,
  APP_COLOR_PICKER.LIGHT_BLUE_PINK_GRADIENT,
  APP_COLOR_PICKER.LIGHT_PURPLE_PINK_GRADIENT,
]

export const BASIC_TEXT_COLOR_OPTIONS = [
  APP_COLOR_PICKER.SUIT_BLUE,
  APP_COLOR_PICKER.BLUE,
  APP_COLOR_PICKER.GREEN,
  APP_COLOR_PICKER.YELLOW,
  APP_COLOR_PICKER.ORANGE,
  APP_COLOR_PICKER.PINK,
  APP_COLOR_PICKER.DARK_GRAY_GRADIENT,
  APP_COLOR_PICKER.ORANGE_RED_GRADIENT,
  APP_COLOR_PICKER.PURPLE_PINK_GRADIENT,
]

export const TEXT_COLOR_OPTIONS = [
  ...[
    APP_COLOR_PICKER.SUIT_BLUE,
    APP_COLOR_PICKER.DARKER_GRAY,
    APP_COLOR_PICKER.KETTLEMAN,
    APP_COLOR_PICKER.CODEX_GREY,
    APP_COLOR_PICKER.TANGLED_WEB,
    APP_COLOR_PICKER.COMPACT_DISC_GREY,
    APP_COLOR_PICKER.SNOWBANK,
    APP_COLOR_PICKER.PURE_WHITE,
  ],
  ...sharedColorOptions,
  ...SHARED_GRADIENTS,
]

export const BASIC_HIGHLIGHT_COLOR_OPTIONS = [
  APP_COLOR_PICKER.LIGHT_BLUE,
  APP_COLOR_PICKER.LIGHT_TEAL,
  APP_COLOR_PICKER.LIGHT_GREEN,
  APP_COLOR_PICKER.LIGHT_YELLOW,
  APP_COLOR_PICKER.LIGHT_ORANGE,
  APP_COLOR_PICKER.BLUSH_RED,
  APP_COLOR_PICKER.LIGHT_BLUE_GREEN_GRADIENT,
  APP_COLOR_PICKER.LIGHT_YELLOW_GREEN_GRADIENT,
  APP_COLOR_PICKER.LIGHT_ORANGE_RED_GRADIENT,
]

export const HIGHLIGHT_COLOR_OPTIONS = [
  APP_COLOR_PICKER.BOX_DARK_GRAY,
  APP_COLOR_PICKER.BOX_DARK_BLUE,
  APP_COLOR_PICKER.BOX_DARK_GREEN,
  APP_COLOR_PICKER.BOX_DARK_YELLOW,
  APP_COLOR_PICKER.BOX_DARK_ORANGE,
  APP_COLOR_PICKER.BOX_DARK_RED,
  APP_COLOR_PICKER.BOX_DARK_PINK,
  APP_COLOR_PICKER.BOX_DARK_PURPLE,

  APP_COLOR_PICKER.BOX_LIGHT_GRAY,
  APP_COLOR_PICKER.BOX_LIGHT_BLUE,
  APP_COLOR_PICKER.BOX_LIGHT_GREEN,
  APP_COLOR_PICKER.BOX_LIGHT_YELLOW,
  APP_COLOR_PICKER.BOX_LIGHT_ORANGE,
  APP_COLOR_PICKER.BOX_LIGHT_RED,
  APP_COLOR_PICKER.BOX_LIGHT_PINK,
  APP_COLOR_PICKER.BOX_LIGHT_PURPLE,

  APP_COLOR_PICKER.LIGHT_GRAY_GRADIENT,
  APP_COLOR_PICKER.LIGHT_BLUE_GRADIENT,
  APP_COLOR_PICKER.LIGHT_BLUE_GREEN_GRADIENT,
  APP_COLOR_PICKER.LIGHT_YELLOW_GREEN_GRADIENT,
  APP_COLOR_PICKER.LIGHT_ORANGE_RED_GRADIENT,
  APP_COLOR_PICKER.LIGHT_RED_PINK_GRADIENT,
  APP_COLOR_PICKER.LIGHT_BLUE_PINK_GRADIENT,
  APP_COLOR_PICKER.LIGHT_PURPLE_PINK_GRADIENT,
]

export const TABLE_CELL_BACKGROUND_COLOR_OPTIONS = [
  ...[
    APP_COLOR_PICKER.BLACK,
    APP_COLOR_PICKER.DARKER_GRAY,
    APP_COLOR_PICKER.DARK_GRAY,
    APP_COLOR_PICKER.MEDIUM_GRAY,
    APP_COLOR_PICKER.GRAY,
    APP_COLOR_PICKER.LIGHT_GRAY,
    APP_COLOR_PICKER.LIGHTER_GRAY,
    APP_COLOR_PICKER.WHITE,
  ],
  ...sharedColorOptions,
  ...SHARED_GRADIENTS,
]

export const CELL_BORDER_COLOR_OPTIONS = [
  APP_COLOR_PICKER.BLACK,
  APP_COLOR_PICKER.DARKER_GRAY,
  APP_COLOR_PICKER.DARK_GRAY,
  APP_COLOR_PICKER.MEDIUM_GRAY,
  APP_COLOR_PICKER.GRAY,
  APP_COLOR_PICKER.LIGHTER_GRAY,
  APP_COLOR_PICKER.WHITE,
  APP_COLOR_PICKER.PURE_WHITE,
  ...sharedColorOptions,
]

export const CALLOUT_COLOR_OPTIONS = [
  APP_COLOR_PICKER.BOX_DARK_GRAY,
  APP_COLOR_PICKER.BOX_DARK_BLUE,
  APP_COLOR_PICKER.BOX_DARK_GREEN,
  APP_COLOR_PICKER.BOX_DARK_YELLOW,
  APP_COLOR_PICKER.BOX_DARK_ORANGE,
  APP_COLOR_PICKER.BOX_DARK_RED,
  APP_COLOR_PICKER.BOX_DARK_PINK,
  APP_COLOR_PICKER.BOX_DARK_PURPLE,

  APP_COLOR_PICKER.BOX_LIGHT_GRAY,
  APP_COLOR_PICKER.BOX_LIGHT_BLUE,
  APP_COLOR_PICKER.BOX_LIGHT_GREEN,
  APP_COLOR_PICKER.BOX_LIGHT_YELLOW,
  APP_COLOR_PICKER.BOX_LIGHT_ORANGE,
  APP_COLOR_PICKER.BOX_LIGHT_RED,
  APP_COLOR_PICKER.BOX_LIGHT_PINK,
  APP_COLOR_PICKER.BOX_LIGHT_PURPLE,

  APP_COLOR_PICKER.LIGHT_GRAY_GRADIENT,
  APP_COLOR_PICKER.LIGHT_BLUE_GRADIENT,
  APP_COLOR_PICKER.LIGHT_BLUE_GREEN_GRADIENT,
  APP_COLOR_PICKER.LIGHT_YELLOW_GREEN_GRADIENT,
  APP_COLOR_PICKER.LIGHT_ORANGE_RED_GRADIENT,
  APP_COLOR_PICKER.LIGHT_RED_PINK_GRADIENT,
  APP_COLOR_PICKER.LIGHT_BLUE_PINK_GRADIENT,
  APP_COLOR_PICKER.LIGHT_PURPLE_PINK_GRADIENT,
]

export const QUOTE_COLOR_OPTIONS = [
  APP_COLOR_PICKER.SUIT_BLUE,
  APP_COLOR_PICKER.AFTER_WORK_BLUE,
  APP_COLOR_PICKER.NATURES_MASTERPIECE,
  APP_COLOR_PICKER.CAFFEINATED_CINNAMON,
  APP_COLOR_PICKER.ESPRESSO_MARTINI,
  APP_COLOR_PICKER.FALU_RED,
  APP_COLOR_PICKER.DARK_RASPBERRY,
  APP_COLOR_PICKER.ORIENTAL_NIGHTS,
  APP_COLOR_PICKER.DARK_SEA,
  APP_COLOR_PICKER.CERULEAN_BLUE,
  APP_COLOR_PICKER.GREEN_GARDENS,
  APP_COLOR_PICKER.XANTHOUS,
  APP_COLOR_PICKER.CHAAT_MASALA,
  APP_COLOR_PICKER.CUTE_CRAB,
  APP_COLOR_PICKER.ORION,
  APP_COLOR_PICKER.PURPLE,
]

export const RIGHT_RAIL_TEXT_COLOR_OPTIONS = [
  APP_COLOR_PICKER.SUIT_BLUE,
  APP_COLOR_PICKER.BLUE,
  APP_COLOR_PICKER.MEDIUM_GREEN,
  APP_COLOR_PICKER.MEDIUM_YELLOW,
  APP_COLOR_PICKER.BRICK_RED,
  APP_COLOR_PICKER.RED_PINK_GRADIENT,
  APP_COLOR_PICKER.DARK_BLUE_GRADIENT,
]

export const RIGHT_RAIL_HIGHLIGHT_COLOR_OPTIONS = [
  APP_COLOR_PICKER.LIGHT_GRAY,
  APP_COLOR_PICKER.LIGHT_BLUE,
  APP_COLOR_PICKER.LIGHT_GREEN,
  APP_COLOR_PICKER.LIGHT_YELLOW,
  APP_COLOR_PICKER.BLUSH_RED,
  APP_COLOR_PICKER.LIGHT_YELLOW_GREEN_GRADIENT,
  APP_COLOR_PICKER.LIGHT_PURPLE_PINK_GRADIENT,
]

export const NO_HIGHLIGHT_COLOR = 'rgba(0, 0, 0, 0)'
export const DEFAULT_HIGHLIGHT_COLOR = APP_COLOR_PICKER.BOX_LIGHT_PURPLE
export const DEFAULT_BACKGROUND_CELL_COLOR = APP_COLOR_PICKER.PURE_WHITE
export const DEFAULT_BORDER_COLOR = '#eaecef'
export const DEFAULT_CALLOUT_COLOR = APP_COLOR_PICKER.LIGHT_BLUE
export const DEFAULT_QUOTE_COLOR = APP_COLOR_PICKER.CERULEAN_BLUE
